<div class="modal-body">
  <div class="row mb-32">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <p class="header-text poppins">REVIEW DETAILS</p>
      <img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
    </div>
    <div class="col-12">
      <p class="sub-text poppins">Please check all the information before submitting.</p>
    </div>
  </div>

  <div class="row" *ngFor="let key of payloadKeys">
    <div class="col-12">
      <div class="d-flex justify-content-between details">
        <p class="poppins text capitalize">{{ key }}</p>
        <p class="poppins text">{{ payload[key] }}</p>
      </div>
    </div>
  </div>

  <button type="button" class="btn submit" (click)="confirmSubmit()">Submit</button>

</div>
